import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getItems} from '../reducers/cartReducer';
import * as cartReducer from '../reducers/cartReducer';
import {startGetSummary} from '../actions/taxes';
import { compose } from 'redux';
import { isDelivery } from '../selectors/address';

const WithTicketCalculator = WrappedComponent => (props) => {
    const getSummary = () => {
        if (props.ticketLines.ticketItems.length === 0) {
            return;
        }
        props.getSummary({
            ticketItems: props.ticketLines.ticketItems,
            isDelivery: props.isDelivery
        }, 0);
    }
    const rest = {...props, getSummary: getSummary}
    return <WrappedComponent {...rest} />;
}

const mapStateToProps = (state) => {
    return {
      summary: state.summary.summary,
      items: getItems(state),
      isDelivery: isDelivery(state),
      ticketLines: cartReducer.getTicketlines(state),
    };
  };
  
const mapDispatchToProps = (dispatch) => {
    return {
        getSummary: (data, payBypoints) => dispatch(startGetSummary(data, payBypoints)),
    };
};

const composedWithTicketCalculator = compose(
    connect(mapStateToProps, mapDispatchToProps),
    WithTicketCalculator
)

export default composedWithTicketCalculator;
// export default     connect(mapStateToProps, mapDispatchToProps)(),



// WEBPACK FOOTER //
// ./src/decorators/WithTicketCalculator.js